import { API_URL, buildHeaders, handleResponse } from './apiClient';

export const fetchDashboardStats = async (token) => {
  const response = await fetch(`${API_URL}/dashboard/stats`, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke hente dashboard statistikk.');
};

export const fetchAlertOrders = async (token, type) => {
  const response = await fetch(`${API_URL}/dashboard/alert-orders/${type}`, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke hente ordreliste.');
};

export const fetchMachineHours = async (token) => {
  const response = await fetch(`${API_URL}/dashboard/machine-hours`, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke hente maskintimer.');
};

export const fetchProductionSummary = async (token) => {
  const response = await fetch(`${API_URL}/dashboard/production-summary`, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke hente produksjonsoversikt.');
};

export const fetchAbsencesToday = async (token, date) => {
  const query = date ? `?date=${encodeURIComponent(date)}` : '';
  const response = await fetch(`${API_URL}/dashboard/absences-today${query}`, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke hente fravær.');
};

export const fetchTeamInfo = async (token) => {
  const response = await fetch(`${API_URL}/dashboard/team-info`, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke hente team-info.');
};
